import BaseModel from "../base_model.js";
import SalutationEnum from "../../enums/salutation.js.jsx";
import TitleEnum from "../../enums/title.js.jsx"
import YesNoEnum from "../../enums/yes_no.js.jsx";

import { PhoneMask } from "../../constants.js";
import { ProfileAddressModel } from "../profile/profile_address_model.js.jsx";

import LoadCountriesUseCase from "../../use_cases/addresses/countries/list_countries_use_case.js";

class RawUserPersonalInfoModel extends BaseModel {

  rawNestedFormFields(item = undefined) {
    const is_company = item && item.salutation == "firma"
    return [
      {
        name: "salutation",
        displayName: this.fieldDisplayName("salutation"),
        type: "enum",
        enum: SalutationEnum,
        weight: 6
      },
      {
        name: "title",
        displayName: this.fieldDisplayName("title"),
        type: "enum",
        enum: TitleEnum,
        weight: 6
      },
      {
        name: "firstName",
        displayName: is_company ? this.fieldDisplayName("managingDirectorFirstName") : this.fieldDisplayName("firstName"),
        type: "text",
        weight: is_company ? 12 : 6,
      },
      {
        name: "lastName",
        displayName: is_company ? this.fieldDisplayName("managingDirectorLastName") : this.fieldDisplayName("lastName"),
        type: "text",
        weight: is_company ? 12 : 6,
      },
      {
        name: "companyName",
        displayName: this.fieldDisplayName("companyName"),
        type: "text",
        weight: 12,
      },
      {
        name: "birthName",
        displayName: this.fieldDisplayName("birthName"),
        type: "text",
      },
      {
        name: "birthDate",
        displayName: this.fieldDisplayName("birthDate"),
        type: "dateTime",
      },
      {
        name: "birthPlace",
        displayName: this.fieldDisplayName("birthPlace"),
        type: "text",
      },
      {
        name: "email",
        displayName: this.fieldDisplayName("email"),
        type: "text"
      },
      {
        name: "phoneNumber",
        displayName: this.fieldDisplayName("phoneNumber"),
        type: "phone",
        mask: PhoneMask,
      },
      {
        name: "mobilePhoneNumber",
        displayName: this.fieldDisplayName("mobilePhoneNumber"),
        type: "phone",
        mask: PhoneMask,
      },
      {
        name: "address",
        type: "nestedModel",
        model: ProfileAddressModel
      },
      {
        name: "citizenship",
        displayName: this.fieldDisplayName("citizenship"),
        type: "model",
        useCase: LoadCountriesUseCase,
        foreignKey: "citizenshipId",
        weight: 6
      },
      {
        name: "hasUsTaxLiability",
        displayName: this.fieldDisplayName("hasUsTaxLiability"),
        type: "enum",
        enum: YesNoEnum,
        weight: 6
      },
      {
        name: "politicallyExposed",
        displayName: this.fieldDisplayName("politicallyExposed"),
        type: "enum",
        enum: YesNoEnum,
        weight: 6
      }
    ]
  }

  i18nScope() {
    return "model.users.personal_info";
  }

  displayValue(item) {
    if(!item) {
      return undefined;
    }
    if(item.salutation == "firma") {
      return item.companyName
    }
    let names = []
    if(item.firstName) {
      names.push(item.firstName);
    }
    if(item.lastName) {
      names.push(item.lastName);
    }
    if(names.length === 0)
      return undefined;
    return names.join(" ");
  }

}
const UserPersonalInfoModel = new RawUserPersonalInfoModel();

export { RawUserPersonalInfoModel, UserPersonalInfoModel }
